import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { PricingCardTypeSelectComponent } from '@App/pages/pricing/pricing-card-type-select/pricing-card-type-select.component';
import { CardPackageService } from '@App/modules/cards-packages/services';
import { StorageService } from '@Shared/services';
import { AppSettings } from '@Shared/app.settings';
import { PitchCardTypeEnum } from '@App/common/enums';

@Component({
  selector: 'app-pitchcard-select-plan-modal',
  standalone: true,

  imports: [CommonModule, DialogModule, PricingCardTypeSelectComponent],
  templateUrl: './pitchcard-select-plan-modal.component.html'
})
export class PitchCardSelectPlanModalComponent extends PitchCardModalBase {
  @Input() showSelectPlanDialog: any;
  @Input() selectPlanBusinessId: any;
  @Input() isMobile: any;
  @Output() planCleared = new EventEmitter<void>();

  private cardPackagesService = inject(CardPackageService);
  private storageService = inject(StorageService);
  private router = inject(Router);

  onSelectPlanPaymentSuccess(payload: {
    id: string | number;
    businessType: string;
  }) {
    this.onFlag('showSelectPlanDialog', false);
    this.planCleared.emit();
    const type =
      payload?.businessType === 'resume'
        ? PitchCardTypeEnum.Resume
        : PitchCardTypeEnum.Employee;
    this.cardPackagesService.selectedType = type;
    this.storageService.setSession(
      AppSettings.DRAFT_BUSINESS_ID,
      payload?.id ?? null
    );
    this.router.navigate(['create']).then();
  }
}
